import { useMemo } from 'react';
import { useSociety } from '@/features/societies/hooks/useSocieties';

/**
 * Indique si la société courante est propriétaire de sa stratégie garantie.
 * Retourne `false` quand warrantyPolicyOwnerId pointe vers le parent (= membre d'un groupe).
 * Dans ce cas, seul le parent peut créer/déplacer/colorer les garanties.
 */
export const useIsWarrantyPolicyOwner = (societyId: string | undefined): boolean => {
  const { data: society } = useSociety(societyId);

  return useMemo(() => {
    if (!society || !societyId) return true;

    const warrantyPolicyOwnerId =
      society.groupConfiguration?.warrantyPolicyOwnerId ??
      society.ownConfiguration?.warrantyPolicyOwnerId ??
      null;

    // Décentralisée (null) ou société courante = owner → autorisé
    if (!warrantyPolicyOwnerId || warrantyPolicyOwnerId === societyId) {
      return true;
    }

    // Le owner est un parent → la société courante ne peut pas gérer
    return false;
  }, [society, societyId]);
};
